import { Component, Inject } from '@angular/core';
import { debounceTime, delay, distinctUntilChanged, filter, map, of, startWith, Subject, switchMap, takeUntil, tap } from 'rxjs';
import { StudentCounsellingReportService } from '../student-counselling-report.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ToastmessageService } from 'src/app/toastmessage.service';
import { ActivatedRoute } from '@angular/router';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { DialogdataService } from '../dialogdata.service';
import { StudentdialogdataService } from '../studentdialogdata.service';

@Component({
  selector: 'app-studentreport-dialog',
  templateUrl: './studentreport-dialog.component.html',
  styleUrls: ['./studentreport-dialog.component.scss']
})
export class StudentreportDialogComponent {
  counsellingReport!: FormGroup;
  Academicyearlist: any[] = [];
  stateOptions: any;
  cityOptions: any;
  campusOptions: any;
  counserlistOptions: any;
  ReasonsOptions: any;
  IdentifiedOptions: any;
  stateId: any;
  cityId: any;
  campusid: any;
  reasonId: any;
  AcademicOptions: any;
  citylist: any;
  campuslist: any;
  counserlerlist: any;
  Reasonslist: any;
  issueslist: any[];
  private reasonLoaded = false;
  private destroy$ = new Subject<void>();
  shouldClearReason = true;
  allReasonCategoryData: any[];
  createby: any;

  constructor(
    private dialogRef: MatDialogRef<StudentreportDialogComponent>,
    private cacheService: DialogdataService,
    private verification: StudentCounsellingReportService,
    private counsellingDataService: StudentdialogdataService
  ) { }

  ngOnInit(): void {
    this.counsellingReport = new FormGroup({
      StateControl: new FormControl('', Validators.required),
      StateControl2: new FormControl('', Validators.required),
      Academic: new FormControl('', Validators.required),
      Academic12: new FormControl('', Validators.required),
      CampusControl: new FormControl('', Validators.required),
      CampusControl2: new FormControl('', Validators.required),
      cityControl: new FormControl('', Validators.required),
      cityControl12: new FormControl('', Validators.required),
      campusControl: new FormControl('', Validators.required),
      campusControl12: new FormControl('', Validators.required),
      selectedDate: new FormControl('', Validators.required),
      CounsellerControl: new FormControl('', Validators.required),
      CounsellerControl12: new FormControl('', Validators.required),
      ReasonsControl: new FormControl('', Validators.required),
      ReasonsControl2: new FormControl('', Validators.required),
      IdentifiedControl: new FormControl('', Validators.required),
      IdentifiedControl2: new FormControl('', Validators.required),
    });

    this.loadAcademicYears();
    // this.getReasons();
    this.restoreCachedFormAndTriggerApis();
  }

  restoreCachedFormAndTriggerApis() {
    this.counsellingDataService.getFormData().subscribe((data: any) => {
      if (data) {
        this.counsellingReport.patchValue(data);
        if (data.StateControl) this.getCity(data.StateControl);
        if (data.cityControl) this.getCampus(data.cityControl);
        if (data.campusControl) this.getCounseller(data.campusControl);
        // if (data.ReasonsControl) this.getIssues(data.ReasonsControl);
      }
    });

    this.getStates();
    // this.getReasons();
  }

  loadAcademicYears() {
    this.verification.getacademic().subscribe((res: any) => {
      this.Academicyearlist = (res as string[]).map(year => ({ year }));
      this.AcademicOptions = this.counsellingReport.get('Academic12')?.valueChanges.pipe(
        startWith(''),
        map(value => this.Filter(value, this.Academicyearlist, 'year'))
      );
    });
  }

  getStates() {
    this.cacheService.getStates().subscribe((res: any) => {
      this.stateOptions = this.counsellingReport.get('StateControl2')?.valueChanges.pipe(
        startWith(''),
        map(value => this.Filter(value, res, 'stateName'))
      );
    });
  }

  getCity(stateId: any) {
    this.stateId = typeof stateId === 'object' ? stateId.stateId : stateId;
    this.cacheService.getCity(this.stateId).subscribe((res: any) => {
      this.cityOptions = this.counsellingReport.get('cityControl12')?.valueChanges.pipe(
        startWith(''),
        map(value => this.Filter(value, res, 'cityName'))
      );
    });
  }

  getCampus(cityId: any) {
    this.cityId = typeof cityId === 'object' ? cityId.cityId : cityId;
    this.cacheService.getCampus(this.cityId).subscribe((res: any) => {
      this.campusOptions = this.counsellingReport.get('CampusControl2')?.valueChanges.pipe(
        startWith(''),
        map(value => this.Filter(value, res, 'campusName'))
      );
      if(this.cityId){
        this.checkAndFetchReasons();
       }
    });
  }


  getCounseller(campusId: any) {
    this.campusid = typeof campusId === 'object' ? campusId.campusId : campusId;
    this.cacheService.getCounsellors(this.campusid).subscribe((res: any) => {
      if (res && res.length > 0) {
        this.counserlistOptions = this.counsellingReport.get('CounsellerControl12')?.valueChanges.pipe(
          startWith(''),
          map(value => this.Filter(value, res, 'empName'))
        );
      }
    this.campusid = typeof campusId === 'object' ? campusId.campusId : campusId;
      if(this.campusid){
       this.checkAndFetchReasons();
      }
    });
  }

  getReasons() {
    this.cacheService.getReasons().subscribe((res: any) => {
      res = res || []; 
   
      this.ReasonsOptions = this.counsellingReport.get('ReasonsControl2')?.valueChanges.pipe(
        startWith(''),
        map(value => this.Filter(value, res, 'type'))
      );
      this.Reasonslist = res;
     
    });
  }
  getReasonss(empId:any) {
    this.createby = typeof empId === 'object' ? empId.empId : empId;
    if(this.createby){
      this.checkAndFetchReasons();
     }
  }
  // getIssues(reasonId: any) {
  //   this.reasonId = typeof reasonId === 'object' ? reasonId.counselCatId : reasonId;
  //   this.cacheService.getIssues(this.reasonId).subscribe((res: any) => {
  //     this.IdentifiedOptions = this.counsellingReport.get('IdentifiedControl2')?.valueChanges.pipe(
  //       startWith(''),
  //       map(value => this.Filter(value, res, 'reasonName'))
  //     );
  //   });
  // }
  checkAndFetchReasons() {
    const academicYear = this.counsellingReport.get('Academic')?.value;
    const cityId = this.cityId;
    const campusId = this.campusid;
    const counsellorId = this.createby;
  
    if (academicYear && cityId ) {
      this.getReasonsAndIssues();
    }
  }

  getReasonsAndIssues() {
    const academicYear = this.counsellingReport.get('Academic')?.value;
    const cityId =  this.cityId 
    const campusId = this.campusid
    const counsellorId = this.createby
    this.cacheService.getCategoryDetails({ academicYear, cityId, campusId, counsellorId, }).subscribe((res: any) => {
      const allCategories = res || [];
      this.Reasonslist = allCategories.map((cat: any) => ({
        counselCatId: cat.counselCatId,
        type: cat.categoryName
      }));
  
      this.ReasonsOptions = this.counsellingReport.get('ReasonsControl2')?.valueChanges.pipe(
        startWith(''),
        map(value => this.Filter(value, this.Reasonslist, 'type'))
      );
  
     
      this.allReasonCategoryData = allCategories;
    });
  }
  getIssues(reasonId: any) {
    this.reasonId = typeof reasonId === 'object' ? reasonId.counselCatId : reasonId;
  
    const selectedCategory = this.allReasonCategoryData.find(cat => cat.counselCatId === this.reasonId);
    const issuesList = selectedCategory?.categoryReasons || [];
  
    this.IdentifiedOptions = this.counsellingReport.get('IdentifiedControl2')?.valueChanges.pipe(
      startWith(''),
      map(value => this.Filter(value, issuesList, 'reasonName'))
    );
  }

  onAcademicYearChange(selectedYear: string) {
    this.getStates(); 
  }
  getCampus1() { }
  Filter(value: string, list: any[], name: string): any[] {
    const searchValue = value?.toLowerCase().trim();
    return list.filter(item => item[name]?.toLowerCase().includes(searchValue));
  }
  getReport() {
    const form = this.counsellingReport.value;
    if (!form.Academic || !form.StateControl || !form.cityControl) {
      alert('Please fill required fields');
      return;
    }
    const paramsObj = {
      academicYear: form.Academic,
      stateId: this.stateId,
      cityId: this.cityId,
      campusId: form.campusControl || '',
      createdBy: form.CounsellerControl || '',
      counselCatId: form.ReasonsControl || '',
      counselCategoryReasonIds: form.IdentifiedControl || '',
    };
    this.counsellingDataService.setFormData(this.counsellingReport.value); 
    this.dialogRef.close({ params: paramsObj });
  }
 
  clearAll() {
    this.counsellingReport.reset();
    this.counsellingDataService.clearFormData();
    this.cacheService.clearAll();
  }
  clearState() {
    this.counsellingReport.get('StateControl')?.reset();
    this.shouldClearReason = true;
    this.clearCity();
  }
  clearCity() {
    // const laststateId = this.cacheService.getLastCityId();
    this.counsellingReport.get('cityControl')?.reset();
    this.cityOptions = of([]).pipe(delay(0));
    this.citylist = [];
    // if(laststateId!==this.stateId){
    // this.citylist = [];
    // }
    // this.cacheService.clearCityCache(); 
    this.clearCampus();
  }
  clearCampus() {
    // const lastCityId = this.cacheService.getLastcampusId();
    this.counsellingReport.get('campusControl')?.reset();
    this.campusOptions = of([]).pipe(delay(0));
    this.campuslist = [];
    // if(lastCityId!==this.cityId){
    // this.campuslist = [];
    // }
    // this.cacheService.clearCampusCache()
    this.clearCounsler(); 
  }
  clearCounsler() {
    // const lastcampusId = this.cacheService.getLastcounsellerId();
    this.counsellingReport.get('CounsellerControl')?.reset();
    this.counserlistOptions = of([]).pipe(delay(0));
    this.counserlerlist = [];
    // if(lastcampusId!==this.campusid){
    // this.counserlerlist = [];
    // }
    // this.cacheService.clearCounsellorCache()
    this.clearReason();
  }
  clearReason() {
    this.counsellingReport.get('ReasonsControl')?.reset();
    this.ReasonsOptions = of([]).pipe(delay(0));
    this.Reasonslist = [];
    if (this.shouldClearReason) {
      this.cacheService.clearReasonsCache();
    }
    this.clearIdentification();
  }
  clearIdentification() {
    this.counsellingReport.get('IdentifiedControl')?.reset();
    this.issueslist = [];
  }
}
